var _path, _path2, _g, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrantFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 211,
    viewBox: "0 0 212 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 211C164.266 211 211.5 163.766 211.5 105.5C211.5 47.234 164.266 0 106 0C47.734 0 0.5 47.234 0.5 105.5C0.5 163.766 47.734 211 106 211Z",
    fill: "#F7F9FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4178_1758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 212,
    height: 211
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 211C164.266 211 211.5 163.766 211.5 105.5C211.5 47.234 164.266 0 106 0C47.734 0 0.5 47.234 0.5 105.5C0.5 163.766 47.734 211 106 211Z",
    fill: "#F7F9FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4178_1758)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.4014,
    y: 74.6113,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.8506,
    y: 69.0605,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6055,
    y: 63.5098,
    width: 119.041,
    height: 169.001,
    rx: 4,
    fill: "white",
    stroke: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4326,
    y: 74.8057,
    width: 104.082,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4326,
    y: 89.0039,
    width: 4.85716,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7598,
    y: 89.0039,
    width: 32.6124,
    height: 4.85716,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7598,
    y: 96.6367,
    width: 95.7555,
    height: 18.0409,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4326,
    y: 125.086,
    width: 4.85716,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7598,
    y: 125.086,
    width: 32.6124,
    height: 4.85716,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7598,
    y: 133.413,
    width: 84.6534,
    height: 9.02044,
    fill: "#EDEFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4326,
    y: 153.535,
    width: 4.85716,
    height: 4.85716,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7598,
    y: 153.535,
    width: 32.6124,
    height: 4.85716,
    fill: "#C6CAC9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1465,
    y: 162.082,
    width: 95.0666,
    height: 60.9861,
    fill: "#EDEFF0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.843,
    cy: 36.5881,
    r: 14.1565,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.993 62C174.71 62.0033 171.458 61.3589 168.425 60.1038C165.391 58.8486 162.634 57.0073 160.313 54.6853C157.991 52.3633 156.151 49.6061 154.896 46.5716C153.641 43.5372 152.997 40.2849 153 37.0011V36.5011C153.1 31.5999 154.638 26.8361 157.422 22.8018C160.207 18.7675 164.115 15.6406 168.661 13.8098C173.208 11.9789 178.192 11.5248 182.994 12.5039C187.796 13.483 192.205 15.8522 195.672 19.3169C199.171 22.8131 201.553 27.2688 202.519 32.12C203.485 36.9713 202.99 42 201.097 46.5697C199.204 51.1395 195.998 55.0449 191.886 57.7916C187.773 60.5383 182.938 62.0029 177.993 62ZM177.993 40.5259L184.466 47.0007L187.99 43.4758L181.517 37.0011L187.99 30.5264L184.466 27.0015L177.993 33.4763L171.52 27.0015L167.996 30.5264L174.469 37.0011L167.996 43.4758L171.52 47.0007L177.993 40.5284V40.5259Z",
    fill: "#FE1A00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantFailed);
export default __webpack_public_path__ + "static/media/grantFailed.c382ec9ec58b70540615d06e6e50964c.svg";
export { ForwardRef as ReactComponent };